import type React from 'react'

import { useState } from 'react'
import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { InputBox, InputCreditCardSC } from './PopupComponents.styled'

export interface IInputCvvCreditCard {
  description: string
  errorMessage?: string
  onChangeInput: (arg: string) => void
}

const CVV_MAX_LENGTH = 4

export const InputCvvCreditCard = ({
  description,
  errorMessage,
  onChangeInput,
}: IInputCvvCreditCard) => {
  const [validValue, setValidValue] = useState('')
  const handleCvvInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.validity.valid ? e.target.value : validValue
    setValidValue(newValue)
    onChangeInput(newValue)
  }

  return (
    <InputCreditCardSC errorMessage={errorMessage!}>
      <InputBox
        type='password'
        name='ccv'
        maxLength={CVV_MAX_LENGTH}
        autoComplete='ccv'
        placeholder='CVV'
        onChange={handleCvvInputChange}
        inputMode='numeric'
        pattern='^\d*$'
        value={validValue}
      />
      <TextBox
        maxLines={2}
        font={TextBoxTypes.Caption4}
        color={TextBoxColors.TEXT_ICON_SECONDARY}
        title={description}
      />
    </InputCreditCardSC>
  )
}
